import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Label,
    Cell
  } from "recharts";
  
  export interface InputProps {
    data: any,
    label:string,
    dataKey:string
  }
  export default function OneBarChart({data,label,dataKey}:InputProps) {
    return (
      <>
      <BarChart
        width={500}
        height={250}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis>
          <Label
           style={{
               textAnchor: "middle",
               fontSize: "130%",
               fill: "black",
               backgroundColor:'red'
           }}
        angle={270} 
        value={label} /></YAxis> 
        
        <Tooltip />
        <Bar dataKey={dataKey} fill="#8884d8">
        {
          data.map((entry: { color: string | undefined; }, index: any) => (
           <Cell key={`cell-${index}`} fill={entry.color} />
           ))
         }
        </Bar>
        <Bar dataKey="sell" fill="#82ca9d" />
      </BarChart>
      </>
    );
  }